import {PatientCommandParams} from "./PatientCommandParams";
import {Command} from "./Command";

export enum PatientConsentType {
    OAU = 'OAU', // Kontaktné a ICE údaje pacienta + Kontaktné údaje PS (Poskytovanie identifikačných údajov osoby podľa zákona 153/2013 § 5 (1) a))
    OUP = 'OUP',  // Osobný účet poistenca (Poskytovanie informácií z účtu poistenca podľa zákona 153/2013 § 5 (1) c))
    PHR = 'PHR', // Vlastné záznamy osoby (Poskytovanie vlastných záznamov pacienta podľa zákona 153/2013 § 5 (1) d))
    LIEK = 'LIEK', // Medikačná história (Poskytovanie medikačných záznamov podľa zákona 153/2013 § 5 (1) b) 12.)
    REC = 'REC', // Lekárske predpisy a lekárske poukazy (Poskytovanie preskripčných záznamov podľa zákona 153/2013 § 5 (1) b) 10.)
    DISP = 'DISP', // Záznam o výdaji lieku/zdr. Pomôcky (Poskytovanie dispenzačných záznamov podľa zákona 153/2013 § 5 (1) b) 11.)
    PSU = 'PSU', // Pacientsky sumár + Aktívna medikácia + Očkovania (Poskytovanie pacientskeho sumáru podľa zákona 153/2013 § 5 (1) b) 1.
    DPS = 'DPS', // Doplnkové zdravotné údaje PS (Poskytovanie doplnkových zdravotných údajov osoby podľa zákona 153/2013 § 5 (1) b) 15.)
    LBZ = 'LBZ', // Laboratórne žiadanky (Poskytovanie žiadaniek na vyšetrenia spoločných vyšetrovacích a liečebných zložiek vrátane popisu vzorky podľa zákona 153/2013 § 5 (1) b) 3.)
    LBV = 'LBV', // Laboratórne výsledky (Poskytovanie záznamov o výsledku vyšetrenia spoločných vyšetrovacích a liečebných zložiek podľa zákona 153/2013 § 5 (1) b) 4.)
    VVP = 'VVP', // Vyšetrenia pacienta a lekárske správy (Poskytovanie záznamov z ambulantnej zdravotnej starostlivosti a ústavnej zdravotnej starostlivosti podľa zákona 153/2013 § 5 (1) b) 8. a 9.)
    VLA = 'VLA', // Odporúčanie (výmenný lístok) na ambulantnú ZS (Poskytovanie záznamov o odporúčaní lekára na špecializovanú ambulantnú zdravotnú starostlivosť podľa zákona 153/2013 § 5 (1) b) 6.)
    VLU = 'VLU', // Odporúčanie (výmenný lístok) na ústavnú ZS (Poskytovanie záznamov o odporúčaní lekára na prijatie do ústavnej zdravotnej starostlivosti podľa zákona 153/2013 § 5 (1) b) 7.)
}

export type WritePatientConsentParams = PatientCommandParams & {
    type: PatientConsentType,
    validFrom: string,
    withPatientPresence: true
};

export const WritePatientConsent = (params: WritePatientConsentParams): Command => {
    return {
        operation: 'ZapisSuhlasOsobyPrePZS',
        params
    }
}